"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CloseContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBTag = require("../HBTag/HBTag.styles");
var _HBTag2 = require("../HBTag/HBTag.types");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _Close = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close16"));
var _Close2 = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close12"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _mixins = require("../../styles/mixins");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var HBTag = function HBTag(_ref) {
  var testIdName = _ref.testIdName,
    testId = _ref.testId,
    className = _ref.className,
    label = _ref.label,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _HBTag2.TagTheme.Default : _ref$theme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _HBTag2.TagSize.Medium : _ref$size,
    _ref$isHighlighted = _ref.isHighlighted,
    isHighlighted = _ref$isHighlighted === void 0 ? false : _ref$isHighlighted,
    onChange = _ref.onChange,
    onClickRemove = _ref.onClickRemove,
    Icon = _ref.icon;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'tag',
    componentName: 'HBTag'
  });
  var CloseIcon = size === _HBTag2.TagSize.Small ? _Close2["default"] : _Close["default"];
  return /*#__PURE__*/_react["default"].createElement(_HBTag.Tag, {
    className: className,
    theme: theme,
    size: size,
    isClickable: !!onChange,
    state: isHighlighted ? _HBTag2.TagState.Highlighted : _HBTag2.TagState.Default,
    onClick: onChange,
    "data-testid": finalTestId
  }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, null), label, !!onClickRemove && /*#__PURE__*/_react["default"].createElement(CloseContainer, {
    onClick: onClickRemove
  }, /*#__PURE__*/_react["default"].createElement(CloseIcon, {
    color: _colors["default"].neutral700
  })));
};
var _default = exports["default"] = HBTag; // -------------------------------- Styles -------------------------------- //
var CloseContainer = exports.CloseContainer = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBTag__CloseContainer",
  componentId: "sc-hnhphp-0"
})(["margin-left:6px;cursor:pointer;display:flex;align-items:center;z-index:1;", " i{line-height:0;}"], _mixins.hideInPrint);
//# sourceMappingURL=HBTag.js.map